import { cx } from "../../../../styled-system/css";
import { styles } from "./Accordion.styles";
import { IAccordionItem } from "types";
import { AccordionItem } from "./AccordionItem";

interface Props {
  items: IAccordionItem[];
  iconFromCMS?: boolean;
  accordionWrapperStyles?: string;
}

export const Accordion: React.FC<Props> = ({ items, iconFromCMS, accordionWrapperStyles }) => {
  return (
    <div className={cx(styles.divWrapper(), accordionWrapperStyles)}>
      {items.map((item) => (
        <AccordionItem key={`accordion-item-${item.title}`} item={item} iconFromCMS={iconFromCMS} />
      ))}
    </div>
  );
};
